
export class FilterParameterGroup {
    description!: string;
}